import styles from './cookieinfo.css';
import Icon from '../icon/icon.js';

function refreshPage() {
  const { origin, pathname } = window.location;
  const pathArr = pathname.split('/');
  pathArr.pop();
  const joinedArr = pathArr.join('/');
  const link = `${origin}${joinedArr}/`;
  window.location.href = link;
}

export function displayCookieDisabledInfo() {
  const cookieDisabledInfo = document.querySelector('#cookie-disabled-info');
  if (cookieDisabledInfo === null) {
    const foo = document.querySelector('body');
    const helper = document.createElement('div');
    const valList = `<div id="cookie-disabled-info" class="${styles.modalWrapper__show}">
      <div class="${styles.modalDialog}">
        <div class="${styles.modalBody}">
          <span role='icon'>
            <i>${Icon('informationCircle')}</i>
          </span>
          <div class="${styles.enableCookies}">
            Please Enable Cookies to Login
          </div>
          <div class="${styles.browserCookies}">
            Your browser cookies are not enabled.
          </div>
          <div class="${styles.enableinfo}">
            Please enable your browser to accept cookies and then 
            <span class="${styles.refreshPage}" id="refreshlink">refresh this page</span> 
            or close and restart your browser to login.
          </div>
        </div>
      </div>
    </div>`;
    helper.innerHTML = valList;
    while (helper.firstChild) {
      foo.appendChild(helper.firstChild);
    }
    const refreshLink = document.querySelector('#refreshlink');
    if (refreshLink) {
      refreshLink.addEventListener('click', () => {
        refreshPage();
      });
    }
  }
}

export default displayCookieDisabledInfo;
